export default "__VITE_ASSET__302c9bb6__"